/* This version of LightGallery is used on the old Image and Work Galleries. */
import $ from 'jquery';

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// toggle gallery from small cta
$('.js-trigger-gallery').click((e) => {
    e.preventDefault();
    const ctaParent = $(e.target).parent()[0];
    const gallery = $(ctaParent).siblings('.js-gallery').first();
    const firstItem = $(gallery).children('.gallery-item').first();
    $(firstItem).trigger('click');
});


// fired immediately after each slide transition
$('.js-gallery').on('onAfterSlide.lg', () => {
    focusExpandedImage();
});

function addCloseIcon() {
    // add a custom close icon - cloned as appending it will only work once
    const closeIcon = $('.js-gallery-close').clone();
    $('.lg-toolbar').append(closeIcon[0]);

    bindCloseEvents(closeIcon);
}

function bindCloseEvents(closeIcon) {
    $(closeIcon).click((e) => {
        e.preventDefault();
        $('.lg-close').trigger('click');
    });
}

function addAltText() {
    const caption = $('.lg-outer')
        .find('.lg-sub-html')
        .find('.gallery-item__title');
    const expandedImage = $('.lg-outer').find('.lg-image');
    const altText = caption.text();

    // add alt text to gallery images when the gallery is open
    expandedImage.attr('alt', altText);

    // hide the caption to prevent being re-read by screen readers when the gallery is open
    caption.attr('aria-hidden', true);
}

// focus the current image when viewing full gallery
function focusExpandedImage() {
    const currentImage = $('.lg-current').find('.lg-image');
    currentImage.attr('tabindex', 0);
    currentImage.focus();
}

$('.lightgallery').each(function(index) {    
    lightGallery(document.getElementById(this.id), {
        plugins: [lgVideo],
        addClass: 'gallery-open',
        appendCounterTo: `#lg-content-${index + 1}`,
        download: false,
        licenseKey: 'B2F92F7A-0AF54432-BA258D6A-46CF1712',
        nextHtml:
            '<svg class="gallery__icon gallery__icon--next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.8 103.7"><use xlink:href="#icon_chevron"></use></svg>',
        prevHtml:
            '<svg class="gallery__icon gallery__icon--prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.8 103.7"><use xlink:href="#icon_chevron"></use></svg>',
        selector: '.gallery-item',
        subHtmlSelectorRelative: true,
        gotoNextSlideOnVideoEnd: false,
        galleryId: index + 1,
        loadYouTubePoster: false,
        // ... other settings
    });
    
    document.getElementById(this.id).addEventListener('lgAfterOpen', () => {
        // disableBodyScroll($('lg-outer'));
    });
    
    document.getElementById(this.id).addEventListener('lgAfterClose', () => {
        clearAllBodyScrollLocks();
    });
    
    document.getElementById(this.id).addEventListener('lgAfterAppendSubHtml', () => {
        addAltText();
        $('.lg-counter').html((i, html) => {
            return html.replace(' /', ' ');
        });
    });
    
    document.getElementById(this.id).addEventListener('lgAfterSlide', () => {
        focusExpandedImage();
    });
});
